import Constants from ".";
import en from "./../commons/locales/en";
import vi from "./../commons/locales/vn";
import LocalizedStrings from "react-localization";

const Strings = new LocalizedStrings({
    en,
    vi
});

const currentLanguage = localStorage.getItem(Constants.StorageKeys.LANGUAGE) || Constants.DefaultLanguage;
Strings.setLanguage(currentLanguage);


export default Strings;
